import * as Constants from '../constants';
import * as WelcomeMat from '../data/WelcomeMat';

export function notifyApiError(error, context) {
  return {
    type: Constants.API_ERROR,
    error,
    context
  };
}

export function openModal(modal, data) {
  return dispatch =>
    dispatch({
      type: Constants.OPEN_MODAL,
      modal,
      data
    });
}

export function closeModal(modal) {
  return dispatch =>
    dispatch({
      type: Constants.CLOSE_MODAL,
      modal
    });
}

export function updateModal(modal, data) {
  return dispatch =>
    dispatch({
      type: Constants.UPDATE_MODAL,
      modal,
      data
    });
}

export function updateForm(form, data) {
  return dispatch =>
    dispatch({
      type: Constants.UPDATE_FORM,
      form,
      data
    });
}

export function openToast(toast, data = true) {
  return dispatch =>
    dispatch({
      type: Constants.OPEN_TOAST,
      toast,
      [toast]: data
    });
}

export function closeToast(toast) {
  return dispatch =>
    dispatch({
      type: Constants.CLOSE_TOAST,
      toast
    });
}

export function initWelcomeMatStatus(name) {
  return dispatch =>
    dispatch({
      type: Constants.UPDATE_WELCOME_MAT,
      name,
      shouldOpen: WelcomeMat.shouldShowWelcomeMat(name)
    });
}

export function closeWelcomeMat(name) {
  return dispatch =>
    WelcomeMat.close(name)
      .then(dispatch({ type: Constants.UPDATE_WELCOME_MAT, shouldOpen: false }))
      .then(closeModal(name)(dispatch));
}

export function updateWelcomeMat(shouldOpen, name) {
  return dispatch =>
    WelcomeMat.update(shouldOpen, name).then(
      dispatch({ type: Constants.UPDATE_WELCOME_MAT, name, shouldOpen })
    );
}
